export class NonCompliance {
    id                      : number;
    category_id             : number;
    fleet_id                : any; 
    driver_id               : any;
    code_id                 : number;
    classicification_id     : number;
    status_id               : number;
    problem_details         : any;
    customer_id             : number;
    file                    : string;
    supporting_docs         : string;
    user_id                 : number;
    run_control_no          : string;
}

export class Corrective_Action {
    id                              : number;
    breach_category_id              : number;
    fleet_id                        : any; 
    driver_id                       : any;
    code_id                         : number;
    classification_id               : number;
    status_id                       : number;
    problem_details                 : number;
    close_out_date                  : any;
    closed_by                       : number;
    raising_person                  : number;
    raising_date                    : any;
    ca_id                           : number;
    ca_short_term_fix               : any;
    ca_short_close_out_person       : number;
    ca_short_close_out_date         : any;
    ca_long_term_fix                : any;
    ca_long_close_out_person        : number;
    ca_long_close_out_date          : any;
    person_involved_name            : any;
    person_involved_date_signed     : any;
    approved_by                     : number;
    approved_date                   : any;
    file                            : any;
    customer_id                     : any;
    ncr_id                          :number;
    ca_name                         :any;
    run_control_no                  : string;
    supporting_docs                 : string;
}
export class CarAuthoirzedUsers {
    id              : number;
    user_id         : number;
    created_by      : number;
    display_name    : string;
}

